module.exports = __webpack_public_path__ + "c570aeaae0089de0ecfb6e889deaabeb.png";